export default {
    setBetaSeller(state, value) {
        state.isBetaSeller = value
        console.log('SET_BETA_SELLER', state.isBetaSeller)
    }
}